if (!customElements.get('pdp-thumbnails')) {
  customElements.define(
    'pdp-thumbnails',
    class PDPThumbnails extends HTMLElement {
      constructor() {
        super();
        this.handleSmoothScrolling();
        this.mediaSelector = this.dataset.type === 'product-modal' ? '.zoom-image' : '.product__media';

        this.scrollableElement = window;
        if (this.dataset.type === 'product-modal') {
          this.scrollableElement = document.querySelector('product-modal');
        }

        this.scrollableElement.addEventListener('scroll', () => {
          this.handleOnScroll();
        });
      }

      getThumbnails() {
        return this.querySelectorAll('.thumbnail');
      }

      handleOnScroll() {


        const productMediaElements = document.querySelectorAll(this.mediaSelector);
        const thumbnails = this.getThumbnails();
        if (!thumbnails.length) return;
        productMediaElements.forEach((o, index) => {
          if (o.getBoundingClientRect().top<=window.innerHeight/2&&o.getBoundingClientRect().top+o.offsetHeight>window.innerHeight/2) {
            thumbnails[index]?.setAttribute('aria-current', true);
          } else {
            thumbnails[index]?.removeAttribute('aria-current');
          }
        });
      }

      handleSmoothScrolling() {
        this.getThumbnails().forEach((element) => {
          element.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = element.getAttribute('href');
            const scrollableElement = this.dataset.type === 'product-modal' ? this.scrollableElement : document;

            scrollableElement.querySelector(targetId).scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            });
          });
        });
      }
    }
  );
}